// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://lkmvezvmamsxjmpyidvz.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxrbXZlenZtYW1zeGptcHlpZHZ6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODE1MzE5MDEsImV4cCI6MjA5NzEwNzkwMX0.hZhNpAcetTc3IK2K8HJm7l9EO7vLWaSqixhKZiPd74I";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    // This integration should NOT manage app auth state.
    // Avoid persisting sessions or refreshing tokens here to prevent conflicts
    // with the primary app Supabase client.
    storage: localStorage,
    persistSession: false,
    autoRefreshToken: false,
  }
});